import styled from 'styled-components'

const StyledInfiniteScroll = styled.div`
  
`

export default StyledInfiniteScroll
